/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 587a44d93123
 */

import * as z from "zod";
import { Folder, Folder$zodSchema } from "./folder.js";

export type FoldersSearchResponse = {
  total_count: number;
  time: number;
  next_cursor?: string | null | undefined;
  folders: Array<Folder>;
};

export const FoldersSearchResponse$zodSchema: z.ZodType<FoldersSearchResponse> =
  z.object({
    folders: z.array(Folder$zodSchema).describe(
      "The folders matching the search.",
    ),
    next_cursor: z.string().nullable().optional().describe(
      "A cursor for pagination.",
    ),
    time: z.int().describe("The time taken to execute the search (ms)."),
    total_count: z.int().describe(
      "The total number of folders matching the search.",
    ),
  });
